<!-- <router-outlet></router-outlet> -->
<!-- <h1>hi</h1> -->
<!-- <div *ngFor="let transcription of transcriptions">
  <app-transcription [transcription]="transcription"></app-transcription>
</div> -->
<app-home></app-home>



